import { Person } from "movieapi";
import * as React from "react";
import CastTable from "./CastTable";

export interface IChooseCastProps {
  data: Person[] | undefined;
  handlePersonChange: (person: Person[]) => void;
}

export default class ChooseCrew extends React.Component<IChooseCastProps, {}> {
  constructor(props: IChooseCastProps) {
    super(props);

    this.state = {};
  }

  public render() {
    return (
      <div>
        <p>Edit Cast</p>
        <p>
          The cast members should be ordered so that the most important cast
          members are at the top of the table. The first three cast members are
          considered the stars of your movie and are given special important by
          the algorithm.
        </p>
        <CastTable
          data={this.props.data}
          handlePersonChange={this.props.handlePersonChange}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/ChooseCast.tsx